import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import { ConeLogisticoConfiguracao } from "../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao";


import { ReactComponent as GraficoSucesso } from "../../../Svgs/ConeLogistico/porcentagem_sucesso.svg";
import { ReactComponent as GraficoTratativa } from "../../../Svgs/ConeLogistico/porcentagem_tratativas.svg";
import { ReactComponent as GraficoSemNc } from "../../../Svgs/ConeLogistico/porcentagem_sem_nc.svg";
import { ReactComponent as GraficoEventos } from "../../../Svgs/ConeLogistico/porcentagem_eventos.svg";
import { ReactComponent as GraficoAutomatico } from "../../../Svgs/ConeLogistico/valor_automatico.svg";
import { ReactComponent as GraficoAssistido } from "../../../Svgs/ConeLogistico/valor_assistido.svg";


const ConeLogisticoConfiguracaoGraficoDireitaTab = (props: any) => {
    const [coneLogisticoConfiguracao, setConeConfiguracao] = useState<any>(new ConeLogisticoConfiguracao());

    useEffect(() => {
        console.log(props);
        if (props.coneLogisticoConfiguracao) {
            setConeConfiguracao(props.coneLogisticoConfiguracao);
        }
    }, [props.coneLogisticoConfiguracao]);

    return (
    <div>
        <div className="row">
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Acumulado Em Risco"
                    field='cor_valor_acumulado_em_risco'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoAutomatico />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Acumulado"
                    field='cor_valor_acumulado'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoAssistido />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Sucesso"
                    field='cor_sucesso_grafico_direita'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoSucesso />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Tratativa"
                    field='cor_tratativa_grafico_direita'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoTratativa />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Sem NC"
                    field='cor_sem_nc'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoSemNc />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Eventos"
                    field='cor_eventos_grafico_direita'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
                <GraficoEventos />
            </div>
  
        </div>
        <div className="row">
        <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Padrão"
                    field='cor_padrao_grafico_direita'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
            </div>
            <div className="col-md-2 mb-2">
                <ColorFieldComponent
                    label="Cor Fonte"
                    field='cor_fonte_grafico_direita'
                    model={coneLogisticoConfiguracao}
                    colorChangedCallback={props.colorChangedCallback}
                />
            </div>
        </div>
    </div>
    );
}

export default ConeLogisticoConfiguracaoGraficoDireitaTab;